module.exports = __webpack_public_path__ + "static/media/talk2partners_logo.ce459e5e.jpeg";